module.exports = __webpack_public_path__ + "static/media/mySvg.6d3ab076.svg";